import { useState, useRef } from 'react'
import { Dialog, DialogClose, DialogContent } from 'src/@/components/ui/dialog'
import { Button } from 'src/@/components/ui/button'
import moment from 'moment'
import Iconify from 'src/components/Iconify'

export default function ZoomableImage({ src, alt, open, onClose, type = 'image' }) {
  const isVideo = type === 'video'
  const [zoom, setZoom] = useState(1)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const containerRef = useRef(null)
  const startPosition = useRef({ x: 0, y: 0 })

  if (!src) return null

  const handleZoom = (delta) => {
    setZoom((prev) => {
      const newZoom = Math.min(Math.max(prev + delta, 1), 3)
      return newZoom
    })
  }

  const handleWheelZoom = (event) => {
    event.preventDefault()
    const delta = event.deltaY < 0 ? 0.1 : -0.1
    handleZoom(delta)
  }

  const resetZoom = () => {
    setZoom(1)
    setPosition({ x: 0, y: 0 })
  }

  const startDragging = (event) => {
    event.preventDefault()
    setIsDragging(true)

    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const clientY = event.touches ? event.touches[0].clientY : event.clientY
    startPosition.current = { x: clientX - position.x, y: clientY - position.y }
  }

  const onDragging = (event) => {
    if (!isDragging) return

    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const clientY = event.touches ? event.touches[0].clientY : event.clientY
    setPosition({ x: clientX - startPosition.current.x, y: clientY - startPosition.current.y })
  }

  const stopDragging = () => {
    setIsDragging(false)
  }

    const handleDownload = () => {
      const a = document.createElement("a");
      a.href = src;
      a.download = `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`;
      a.click();
    };
  

  return (
    <Dialog open={open} onOpenChange={onClose}>
      
      <DialogContent className="max-w-screen h-screen bg-black/60 flex items-center justify-center p-0 m-0 border-0">
      <DialogClose className="absolute top-4 right-4 bg-white rounded-full p-2 z-[9999]">
            <Iconify icon="mdi:close" className="h-6 w-6 text-black" />
        </DialogClose>
        {/* Video: sem pan/zoom/wheel — o <video controls> ja precisa dos
            proprios eventos de mouse pra play/pause/seek, e arrastar/rodar a
            roda do mouse por cima brigaria com esses controles. E tambem sem
            usar o botao de fullscreen NATIVO do navegador: o CSS do balao
            pequeno na conversa (object-fit/max-height) segue valendo dentro
            do fullscreen nativo em alguns navegadores e corta video vertical
            (story). Este modal ja ocupa a tela inteira com object-contain sob
            nosso controle, entao serve como a "visualizacao grande". */}
        <div
          ref={containerRef}
          className={`w-full h-full flex items-center justify-center ${isVideo ? '' : `cursor-${isDragging ? 'grabbing' : 'grab'}`}`}
          onMouseMove={isVideo ? undefined : onDragging}
          onTouchMove={isVideo ? undefined : onDragging}
          onMouseUp={isVideo ? undefined : stopDragging}
          onTouchEnd={isVideo ? undefined : stopDragging}
          onMouseLeave={isVideo ? undefined : stopDragging}
          onWheel={isVideo ? undefined : handleWheelZoom}
        >
          {isVideo ? (
            <video
              src={src}
              controls
              autoPlay
              className="object-contain"
              style={{ maxWidth: '100vw', maxHeight: '100vh' }}
            />
          ) : (
            <img
              src={src}
              alt={alt || ''}
              className="object-contain"
              style={{
                transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
                transformOrigin: 'center',
                transition: isDragging ? 'none' : 'transform 0.2s ease-out',
                maxWidth: '100vw',
                maxHeight: '100vh',
              }}
              onMouseDown={startDragging}
              onTouchStart={startDragging}
            />
          )}
        </div>
        <div className="absolute bottom-6 flex gap-4 bg-white/10 p-4 rounded-lg">
        <Button onClick={handleDownload}>
             Download
          </Button>

          {!isVideo && (
            <>
              <Button onClick={() => handleZoom(-0.2)} disabled={zoom <= 1}>
                ➖ Menos Zoom
              </Button>
              <Button onClick={() => handleZoom(0.2)} disabled={zoom >= 3}>
                ➕ Mais Zoom
              </Button>
              <Button onClick={resetZoom} disabled={zoom === 1}>
                🔄 Resetar
              </Button>
            </>
          )}
          <Button
            onClick={() => {
              resetZoom()
              onClose()
            }}
            className="bg-red-600"
          >
            Fechar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
